import type { HoursSummary } from "../lib/hours";
import { WARN_UNDER_HOURS } from "../content";
import { boldHours } from "../lib/text";

interface Props {
  summary: HoursSummary;
  minHours: number;
  saving: boolean;
  canInteract: boolean;
  onSaveDraft: () => void;
  onSubmit: () => void;
}

export default function SummaryBar({
  summary,
  minHours,
  saving,
  canInteract,
  onSaveDraft,
  onSubmit,
}: Props) {
  return (
    <div className="summary-bar">
      <div className="inner">
        <div className="summary-grid">
          <div className="cell">
            <div className="n">{summary.morningCount}</div>
            <div className="l">伴讀場次</div>
          </div>
          <div className="cell">
            <div className="n">{summary.charityCount}</div>
            <div className="l">公益活動場次</div>
          </div>
          <div className="cell">
            <div className="n">{summary.totalHours}</div>
            <div className="l">已選總服務時數</div>
          </div>
          <div className="cell">
            <div className="n">{summary.met ? 0 : summary.remaining}</div>
            <div className="l">
              距 <strong>{minHours}</strong> 小時還差
            </div>
          </div>
        </div>

        {summary.met ? (
          <div className="status-line ok">
            ✅ 已達最低 <strong>{minHours}</strong> 小時服務時數（目前 {summary.totalHours}{" "}
            小時），可送出最終確認。
          </div>
        ) : (
          <div className="status-line warn">⚠️ {boldHours(WARN_UNDER_HOURS)}</div>
        )}

        {summary.projectedWaitlist > 0 && (
          <div className="status-line warn">
            其中 {summary.projectedWaitlist} 場以你目前的身分為「遞補」名額，建議多勾其他場次。
          </div>
        )}

        <div className="actions">
          <button
            type="button"
            className="btn ghost"
            style={{ flex: 1 }}
            disabled={saving || !canInteract}
            onClick={onSaveDraft}
          >
            {saving ? "處理中…" : "儲存草稿"}
          </button>
          <button
            type="button"
            className="btn primary"
            style={{ flex: 1 }}
            disabled={saving || !canInteract || !summary.met}
            onClick={onSubmit}
          >
            送出最終確認
          </button>
        </div>
      </div>
    </div>
  );
}
